export function icsrmGetDaadRegionFromCountry(country: string) {
  switch (country) {
    case 'AO':
    case 'GQ':
    case 'ET':
    case 'BJ':
    case 'BW':
    case 'BF':
    case 'BI':
    case 'CI':
    case 'DJ':
    case 'ER':
    case 'GA':
    case 'GM':
    case 'GH':
    case 'GN':
    case 'GW':
    case 'CM':
    case 'CV':
    case 'KE':
    case 'KM':
    case 'CG':
    case 'CD':
    case 'LS':
    case 'LR':
    case 'MG':
    case 'MW':
    case 'ML':
    case 'MR':
    case 'MU':
    case 'MZ':
    case 'NA':
    case 'NE':
    case 'NG':
    case 'RW':
    case 'ZM':
    case 'ST':
    case 'SN':
    case 'SC':
    case 'SL':
    case 'ZW':
    case 'SO':
    case 'ZA':
    case 'SD':
    case 'SS':
    case 'SZ':
    case 'TZ':
    case 'TG':
    case 'TD':
    case 'UG':
    case 'CF':
      return 'Afrika Subsahara';
    case 'AU':
    case 'BD':
    case 'BT':
    case 'BN':
    case 'CN':
    case 'CK':
    case 'FJ':
    case 'IN':
    case 'ID':
    case 'JP':
    case 'KH':
    case 'KI':
    case 'KP':
    case 'KR':
    case 'LA':
    case 'MY':
    case 'MV':
    case 'MH':
    case 'FM':
    case 'MN':
    case 'MM':
    case 'NR':
    case 'NP':
    case 'NZ':
    case 'NU':
    case 'PW':
    case 'PG':
    case 'PH':
    case 'SB':
    case 'WS':
    case 'SG':
    case 'LK':
    case 'TH':
    case 'TL':
    case 'TO':
    case 'TV':
    case 'VU':
    case 'VN':
    case 'HK':
    case 'MO':
    case 'TW':
      return 'Asien, Pazifik';
    case 'AG':
    case 'AR':
    case 'BS':
    case 'BB':
    case 'BZ':
    case 'BO':
    case 'BR':
    case 'CL':
    case 'CR':
    case 'DM':
    case 'DO':
    case 'EC':
    case 'SV':
    case 'GD':
    case 'GT':
    case 'GY':
    case 'HT':
    case 'HN':
    case 'JM':
    case 'CO':
    case 'CU':
    case 'MX':
    case 'NI':
    case 'PA':
    case 'PY':
    case 'PE':
    case 'KN':
    case 'LC':
    case 'VC':
    case 'SR':
    case 'TT':
    case 'UY':
    case 'VE':
      return 'Lateinamerika';
    case 'AF':
    case 'EG':
    case 'DZ':
    case 'BH':
    case 'IQ':
    case 'IR':
    case 'IL':
    case 'YE':
    case 'JO':
    case 'QA':
    case 'KW':
    case 'LB':
    case 'LY':
    case 'MA':
    case 'OM':
    case 'PK':
    case 'SA':
    case 'SY':
    case 'TN':
    case 'AE':
    case 'PS':
      return 'Nahost, Nordafrika';
    case 'CA':
    case 'US':
      return 'Nordamerika';
    case 'AM':
    case 'AZ':
    case 'BY':
    case 'GE':
    case 'KZ':
    case 'KG':
    case 'MD':
    case 'RU':
    case 'TJ':
    case 'TM':
    case 'UA':
    case 'UZ':
      return 'Osteuropa, Zentralasien und Südkaukasus';
    case 'AL':
    case 'AD':
    case 'BE':
    case 'BA':
    case 'BG':
    case 'DK':
    case 'EE':
    case 'FI':
    case 'FR':
    case 'GR':
    case 'IE':
    case 'IS':
    case 'IT':
    case 'XK':
    case 'HR':
    case 'LV':
    case 'LI':
    case 'LT':
    case 'LU':
    case 'MT':
    case 'MK':
    case 'MC':
    case 'ME':
    case 'NL':
    case 'NO':
    case 'AT':
    case 'PL':
    case 'PT':
    case 'RO':
    case 'SM':
    case 'SE':
    case 'CH':
    case 'RS':
    case 'SK':
    case 'SI':
    case 'ES':
    case 'CZ':
    case 'TR':
    case 'HU':
    case 'VA':
    case 'GB':
    case 'CY':
      return 'West-, Mittel- und Südosteuropa';
    case 'DE':
    case 'XD':
    case 'XB':
    case 'XC':
    case 'XA':
    default:
      return null; // keine Zuordung
  }
}

export function icsrmGetCitizenshipFromCountry(country: string) {
  const euCountries = [
    'BE',
    'EL',
    'LT',
    'PT',
    'BG',
    'ES',
    'LU',
    'RO',
    'CZ',
    'FR',
    'HU',
    'SI',
    'DK',
    'HR',
    'MT',
    'SK',
    'DE',
    'IT',
    'NL',
    'FI',
    'EE',
    'CY',
    'AT',
    'SE',
    'IE',
    'LV',
    'PL',
  ];
  if (country === 'DE') return 'Deutschland';
  if (euCountries.includes(country)) return 'EU';
  return 'nicht EU';
}
